import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  Cards,
  Inputs,
  Modaal,
  SearchBars,
  Tabbles,
} from "../../../components";
import { PiBinoculars, PiFilePdfThin, PiFirstAidLight } from "react-icons/pi";
import { BsEye } from "react-icons/bs";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const DiagnosticHistory = () => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [showModal1, setShowModal1] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  const getAllAppointmentDetailListData = useSelector(
    (state) => state.doctor.getAllAppointmentDetailListData?.data
  );

  const handleCloseModal = () => {
    setShowModal1(false);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const suffix = (day) => {
      if (day > 3 && day < 21) return "th";
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();

    return `${day}${suffix(day)} ${month} ${year}`;
  };

  const handleDateRangeChange = (range) => {
    setDateRange(range);
  };
  const onSearchClick = () => { };
  return (
    <>
      <SearchBars.SearchBar
        className="search-bar"
        showDate={true}
        datepickermd={3}
        searchColmd={8}
        buttonColmd={1}
        searchGrpClassName="form-group1"
        searchPlaceholder={t("Search")}
        cDateRangePlaceholder={t("select_date")}
        cDateRangeClassname="custom-date-range-picker"
        buttonClassname="btn-solid-Aqua_Teal"
        buttonChildren={<PiBinoculars className="bionCularIcon" />}
        dateRange={dateRange}
        searchValue={search}
        onDateRangeChange={handleDateRangeChange}
        onSearchChange={(e) => setSearch(e.target.value)}
        onSearchClick={onSearchClick}
      />

      <Tabbles.TableBlk
        headerIcon={<PiFirstAidLight className="header-Icn" />}
        heading={t("doctor.diagnostic_report.diagnostic_history")}
        columns={[
          `${t("date")}`,
          `${t("Diagnostic_Report")}`,
          `${t("View")}`]}
        data={getAllAppointmentDetailListData?.result?.diagnosticReports.map(
          (diaReports) => ({
            [t("date")]: formatDate(diaReports.createdDate),
            [t("Diagnostic_Report")]: `${t("Diagnostic_Report")} - ${diaReports?.appDetail?.patientName}`,
            [t("View")]: (
              <div className="editBlkIcon">
                <BsEye
                  className="editIcon"
                  onClick={() => {
                    setSelectedReport(diaReports);
                    setShowModal1(true);
                  }}
                />
              </div>
            ),
          })
        )}
        tabbleSectionClassname="tabble-diagnosis-history"
        tabbleClassname="tabble "
      />
      <Modaal.Modaal
        show={showModal1}
        onHide={handleCloseModal}
        centered="true"
        size="xl"
        title={<h2 className="exado-title-nine">{t("Diagnostic_Report")}</h2>}
        bodyContent={
          <Row md={2} className="g-3">
            <Col>
              <Cards.Cardd
                header={
                  <>
                    <div className="blkIcon">
                      <PiFirstAidLight className="iicon" />
                    </div>
                    <div>
                      <h5 className="exado-title-seven card-header-text">
                        {t("doctor.diagnostic_report.write_current_anamnesis_and_nvestigations")}
                      </h5>
                      <span className="exado_body_text_two card-header-text">
                        {t("doctor.diagnostic_report.current_date")} {" "}
                        {new Date(
                          selectedReport?.createdDate
                        ).toLocaleDateString("en-GB")}
                      </span>
                    </div>
                  </>
                }
                content={
                  <Inputs.FormInputs
                    type="textarea"
                    label={t("doctor.diagnostic_report.enter_current_anamnesis_and_investigations")}
                    value={selectedReport?.describeProblem}
                    readOnly={true}
                    grpClassname={`form-group }`}
                  />
                }
                className="cardd"
              />
            </Col>
            <Col>
              <Cards.Cardd
                header={
                  <>
                    <div className="blkIcon">
                      <PiFirstAidLight className="iicon" />
                    </div>
                    <div>
                      <h5 className="exado-title-seven card-header-text">
                        {t("doctor.diagnostic_report.write_current_diagnostic_conclusion")}
                      </h5>
                      <span className="exado_body_text_two card-header-text">
                        {t("doctor.diagnostic_report.current_date")}{" "}
                        {new Date(
                          selectedReport?.createdDate
                        ).toLocaleDateString("en-GB")}
                      </span>
                    </div>
                  </>
                }
                content={
                  <Inputs.FormInputs
                    type="textarea"
                    placeholder=""
                    label={t("doctor.diagnostic_report.enter_current_diagnostic_conclusion")}
                    value={selectedReport?.diagnosticConclusion}
                    readOnly={true}
                    grpClassname={`form-group }`}
                  />
                }
                className="cardd"
              />
            </Col>
            <Col>
              <Cards.Cardd
                header={
                  <>
                    <div className="blkIcon">
                      <PiFirstAidLight className="iicon" />
                    </div>
                    <div>
                      <h5 className="exado-title-seven card-header-text">
                        {t("doctor.diagnostic_report.add_current_prescription")}
                      </h5>
                      <span className="exado_body_text_two card-header-text">
                        {t("doctor.diagnostic_report.current_date")}{" "}
                        {new Date(
                          selectedReport?.createdDate
                        ).toLocaleDateString("en-GB")}
                      </span>
                    </div>
                  </>
                }
                content={
                  <Inputs.FormInputs
                    type="textarea"
                    placeholder=""
                    label={t("doctor.diagnostic_report.enter_current_suggested_prescription")}
                    value={selectedReport?.prescribeMedicine}
                    grpClassname="form-group"
                    readOnly={true}
                  />
                }
                footer={
                  <>
                    {selectedReport?.prescribeMedicineDocs?.length > 0 &&
                      selectedReport?.prescribeMedicineDocs.map(
                        (doc, index) => (
                          <Link
                            key={index}
                            to={doc.docURL}
                            target="_blank"
                            className="exado-title-seven"
                          >
                            <PiFilePdfThin className="pdficon" />
                            {doc.docName?.length > 50
                              ? doc.docName.substring(0, 50) + "..."
                              : doc.docName || ""}
                          </Link>
                        )
                      )}
                  </>
                }
                className="cardd card-prescription"
              />
            </Col>
            {selectedReport?.additionalDocuments.map((doc, index) => (
              <Col key={index} className="col-card-additional-document">
                <Cards.Cardd
                  header={
                    <>
                      <div className="blkIcon">
                        <PiFirstAidLight className="iicon" />
                      </div>
                      <div>
                        <h5 className="exado-title-seven card-header-text">
                          {t("doctor.diagnostic_report.add_current_additional_documents")}
                        </h5>
                        <span className="exado_body_text_two card-header-text">
                          {t("doctor.diagnostic_report.current_date")}{" "}
                          {new Date(
                            selectedReport?.createdDate
                          ).toLocaleDateString("en-GB")}
                        </span>
                      </div>
                    </>
                  }
                  content={
                    <Inputs.FormInputs
                      type="textarea"
                      placeholder=""
                      label={t("doctor.diagnostic_report.enter_current_suggested_prescription")}
                      value={doc.additionalDocument}
                      grpClassname="form-group"
                      readOnly={true}
                    />
                  }
                  footer={
                    doc.additionalFile.docURL && (
                      <Link
                        key={index}
                        to={doc.additionalFile.docURL}
                        target="_blank"
                        className="exado-title-seven"
                      >
                        <PiFilePdfThin className="pdficon" />
                        {doc.additionalFile.docName?.length > 50
                          ? doc.additionalFile.docName.substring(0, 50) + "..."
                          : doc.additionalFile.docName || "View Document"}
                      </Link>
                    )
                  }
                  className="cardd cardd-additional"
                />
              </Col>
            ))}
          </Row>
        }
        backdrop="static"
        className="input-modal diagnostic-report-modal"
      />
    </>
  );
};

export default DiagnosticHistory;
